import {AxiosError, AxiosResponse} from 'axios';
import {useMutation} from 'react-query';
import postCreateCreditStoreOrderTransaction, {
  IPostCreditStoreOrderTransactionPayload,
} from './postCreateCreditStoreOrderTransaction';

const usePostCreateCreditStoreOrderTransaction = (
  handleAfterSuccess?: (response: AxiosResponse<any>) => void,
  handleOnError?: (statusCode: number | null) => void,
) => {
  return useMutation({
    mutationFn: (payload: IPostCreditStoreOrderTransactionPayload) =>
      postCreateCreditStoreOrderTransaction(payload),

    onSuccess: response => {
      handleAfterSuccess?.(response);
    },

    onError: (error: AxiosError<IAxiosErr>) => {
      const status = error.response?.status ?? null;
      handleOnError?.(status);
    },
  });
};

export default usePostCreateCreditStoreOrderTransaction;
